import { RouteObject } from '@rocketlane/rocket-router';
import { SignalAgentsRemote } from 'components/pages/signal-agents-remote';
import { SecureRoute } from '../route-with-permission-check';
import { ROUTE_PATHS } from '../routes-paths';

export const signalAgentsRoutes: RouteObject[] = [
  {
    path: ROUTE_PATHS.SIGNAL_AGENTS,
    children: [
      {
        index: true,
        element: (
          <SecureRoute>
            <SignalAgentsRemote />
          </SecureRoute>
        ),
      },
      {
        path: ROUTE_PATHS.MATCH_ALL,
        element: (
          <SecureRoute>
            <SignalAgentsRemote />
          </SecureRoute>
        ),
      },
    ],
  },
];
